// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"commonStyles_sectionWrapper__3gPUF","title":"commonStyles_title__2spez","withRoundedBorder":"commonStyles_withRoundedBorder__2tzwA"};